export { futureDateSchema, futureDateUI } from 'platform/shared/health-apps';
export * from './addresses';
export * from './attachments';
export * from './names';
export * from './prefill';
export * from './text';
export * from './titles';

export const blankSchema = { type: 'object', properties: {} };
